"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSimplePaginator = void 0;
const React = __importStar(require("react"));
function createSimplePaginator(items, forPage) {
    const currentPage = 1;
    const count = items.length;
    const pages = Math.ceil(count / forPage);
    const list = items.slice(0, forPage);
    return {
        currentPage,
        list,
        items,
        forPage,
        pages,
    };
}
function useSimplePaginator(items, forPage = 2) {
    const [state, setState] = React.useState(createSimplePaginator(items, forPage));
    React.useEffect(() => {
        if (JSON.stringify(items) !== JSON.stringify(state.items)) {
            setState(createSimplePaginator(items, forPage));
        }
    }, [items, forPage]);
    const bFirst = state.currentPage <= 1;
    const bLast = state.currentPage >= state.pages;
    const bNeeded = state.forPage <= items.length;
    function next() {
        const currentState = { ...state };
        const nextPage = state.currentPage + 1;
        if (nextPage <= state.pages) {
            currentState.list = items.slice((nextPage - 1) * state.forPage, nextPage * state.forPage);
            currentState.currentPage = nextPage;
            setState(currentState);
        }
    }
    async function appendNext() {
        const currentState = { ...state };
        const nextPage = state.currentPage + 1;
        if (nextPage <= state.pages) {
            currentState.list = [
                ...currentState.list,
                ...items.slice((nextPage - 1) * state.forPage, nextPage * state.forPage),
            ];
            currentState.currentPage = nextPage;
            setState(currentState);
        }
    }
    function prev() {
        const currentState = { ...state };
        const prevPage = state.currentPage - 1;
        if (prevPage >= 1) {
            currentState.list = items.slice((prevPage - 1) * state.forPage, prevPage * state.forPage);
            currentState.currentPage = prevPage;
            setState(currentState);
        }
    }
    function go(page) {
        const currentState = { ...state };
        const nextPage = page <= 1 ? 1 : page >= currentState.pages ? currentState.pages : page;
        currentState.list = items.slice((nextPage - 1) * state.forPage, nextPage * state.forPage);
        currentState.currentPage = nextPage;
        setState(currentState);
    }
    return {
        ...state,
        bLast,
        bFirst,
        bNeeded,
        next,
        prev,
        go,
        appendNext,
    };
}
exports.useSimplePaginator = useSimplePaginator;
